import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { compose } from 'recompose';
import { BLANK_IMAGE_URL } from '../../../define/consts/assets';
import { REGION_CANDIDATES } from '../../../define/consts/solution';
import { isClient as isClientMember } from '../../../helpers/auth';
import { propArrayShape, propBool, propFunc, propNumber, propShape, PropTypesAuthToken, } from '../../../helpers/custom-prop-types';
import IsAllLoadingHoc from '../../Layout/Loading/IsAllLoadingHoc';
import Caution from './Parts/Caution';
import Questions from './Parts/Questions';
import RecommendationSliderTemplate from './Parts/RecommendationSlider/RecommendationSliderTemplate';
import SolutionHeaders from './Parts/SolutionHeader';
import SolutionProposalImage from './Parts/SolutionProposalImage';
import SolutionTabContent from './Parts/SolutionTabContent';
import SolutionTabDescriptionOptions from './Parts/SolutionTabDescriptionOptions';
import SolutionTabPerformanceFeature from './Parts/SolutionTabPerformanceFeature';
const OneMainItem = (props) => {
    const { auth, changeTab, currentTab, isDemo, isLoadingRecommendation, item, onClickOrder, onClickProffitOrder, onClickRecommendation, onClickThumbnail, onClickVideo, recommendations, } = props;
    const isClient = isClientMember(auth);
    const organization = item.organization || {};
    const setImages = item.images.length > 0 ? item.images : [BLANK_IMAGE_URL];
    const setImportantList = item.importantImages || [];
    const regionText = REGION_CANDIDATES.map((v, index) => {
        const region = item.regions.find((r) => r.type === v.value);
        if (!region) {
            return '';
        }
        const isOther = index === REGION_CANDIDATES.length - 1;
        return isOther ? region.text : v.label;
    })
        .filter((row) => row)
        .join('\n');
    const tabContents = [
        { index: 0, tab: '概要', text: item.description },
        { index: 1, tab: 'こんな人におすすめ', text: item.solveIssue },
        {
            custom: 'description-options',
            index: 2,
            tab: '成果物・オプション',
        },
        {
            custom: 'performance-feature',
            index: 3,
            tab: '実績・ファームの特徴',
        },
        { index: 4, tab: '対応エリア', text: regionText },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: item.title }) }), _jsx(SolutionHeaders, { auth: auth, isDemo: isDemo, item: item, onClickOrder: onClickOrder, onClickProffitOrder: onClickProffitOrder, onClickVideo: onClickVideo, setImages: setImages }), _jsxs("div", Object.assign({ className: 'l-container l-contents' }, { children: [_jsx("div", Object.assign({ className: 'l-container l-contents' }, { children: _jsx(SolutionProposalImage, { item: item, onClickThumbnail: onClickThumbnail, setImages: setImages, setImportantList: setImportantList }) })), _jsxs("div", Object.assign({ className: 'l-container-12 s-contents' }, { children: [_jsx("h2", { children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8A73\u7D30" }), _jsx("div", Object.assign({ className: 's-contents-inner bg-white' }, { children: _jsxs("div", Object.assign({ className: 'tab-container' }, { children: [_jsx("ul", Object.assign({ className: 'tabs' }, { children: tabContents.map(({ index, tab }) => (_jsx("li", Object.assign({ className: currentTab === index ? 'active' : '' }, { children: _jsx("button", Object.assign({ onClick: () => changeTab(index), type: 'button' }, { children: tab })) }), index))) })), _jsx("div", Object.assign({ className: 'l-tab' }, { children: tabContents.map(({ custom, index, text }) => {
                                                if (custom === 'description-options') {
                                                    return (_jsx(SolutionTabDescriptionOptions, { currentIndex: currentTab, item: item, tabIndex: index }, index));
                                                }
                                                if (custom === 'performance-feature') {
                                                    return (_jsx(SolutionTabPerformanceFeature, { currentIndex: currentTab, item: item, organization: organization, tabIndex: index }, index));
                                                }
                                                return (_jsx(SolutionTabContent, { currentIndex: currentTab, tabIndex: index, text: text }, index));
                                            }) }))] })) }))] }))] })), (isDemo || isClient) && (_jsx(RecommendationSliderTemplate, { isLoading: isLoadingRecommendation, items: recommendations, onClick: onClickRecommendation })), _jsxs("div", Object.assign({ className: 'l-container l-contents' }, { children: [_jsx(Questions, { faq: item.faq }), _jsx(Caution, { text: item.caution })] }))] }));
};
OneMainItem.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    changeTab: propFunc().isRequired,
    currentTab: propNumber().isRequired,
    isDemo: propBool().isRequired,
    isLoadingRecommendation: propBool().isRequired,
    item: propShape().isRequired,
    onClickOrder: propFunc().isRequired,
    onClickProffitOrder: propFunc().isRequired,
    onClickRecommendation: propFunc(),
    onClickThumbnail: propFunc().isRequired,
    onClickVideo: propFunc().isRequired,
    recommendations: propArrayShape().isRequired,
};
OneMainItem.defaultProps = {
    onClickRecommendation: null,
};
const enhance = compose(IsAllLoadingHoc);
export default enhance(OneMainItem);
